<script lang="ts">
  import { preventDefault } from "svelte/legacy";
  import Button from "./atoms/Button.svelte";
  import Heading from "./atoms/Heading.svelte";
  import Estimation from "./molecules/Estimation.svelte";
  import Text from "./atoms/Text.svelte";
  import ZipCode from "./molecules/ZipCode.svelte";
  import type { ChooseAgreementFlow } from "./ChooseAgreement.svelte";

  interface Props {
    flow: ChooseAgreementFlow;
    onComplete: () => void;
    headerLevel?: 1 | 2;
    estimationHeading?: string;
    estimationText?: string;
    residenceText?: string;
    showZipCode?: boolean;
    zipCodeText?: string;
  }

  let {
    flow,
    onComplete,
    headerLevel = 1,
    estimationHeading = "Hur stor är din elförbrukning?",
    estimationText = "För att få ett ungefärligt pris behöver du uppskatta din årliga elförbrukning.",
    residenceText = "Jag bor i ",
    showZipCode = true,
    zipCodeText = "Fyll i ditt postnummer och klicka på ”Beräkna pris” för att se din beräknade månadskostnad.",
  }: Props = $props();

  let facilityInformation = $state({ ...flow.facilityInformation });
  if (
    !facilityInformation.residenceType &&
    facilityInformation.zipcode &&
    flow.requiresLimePurchase
  ) {
    facilityInformation.residenceType = "house";
  }

  let inputEstimationValue = $state(flow.estimation > 0 ? flow.estimation : 20000);
  let zipCodeValid = $state(false);
  let ableToContinue = $state(false);
  let hasPressedContinue = $state(false);

  $effect(() => {
    if (
      inputEstimationValue != undefined &&
      facilityInformation.residenceType &&
      facilityInformation.zipcode !== undefined
    ) {
      ableToContinue =
        zipCodeValid && inputEstimationValue > 0 && !!facilityInformation.residenceType;
    } else {
      ableToContinue = false;
    }
  });

  const onEstimationSubmit = () => {
    if (!ableToContinue) return;
    flow.setEstimation(inputEstimationValue);
    flow.setZipCode(
      facilityInformation.zipcode ? facilityInformation.zipcode.toString() : ""
    );
    flow.setResidenceType(facilityInformation.residenceType!);
    onComplete();
  };
</script>

{#snippet viewHeading(text: string)}
  <Heading level={headerLevel} class="text-Neutral900">{text}</Heading>
{/snippet}

<form class="!bg-transparent flex flex-col gap-3" onsubmit={preventDefault(onEstimationSubmit)}>
  <Estimation
    {residenceText}
    bind:hasPressedContinue
    bind:inputEstimationValue
    bind:residenceType={facilityInformation.residenceType}
  >
    {@render viewHeading(estimationHeading)}
    <Text size="M" variant="secondary">{estimationText}</Text>
  </Estimation>
  {#if showZipCode || !zipCodeValid}
    <ZipCode
      bind:hasPressedContinue
      bind:valid={zipCodeValid}
      bind:zipcode={facilityInformation.zipcode}
      disabled={flow.requiresLimePurchase && facilityInformation.zipcode !== undefined}
    >
      {zipCodeText}
    </ZipCode>
  {/if}
  <Button
    type={"submit"}
    onClick={() => {
      hasPressedContinue = true;
    }}
    disabled={flow.purchaseFlowType == "v1" ? !ableToContinue : false}
    animate={false}
    class="w-full mb-2">Beräkna pris</Button
  >
</form>
